import { useEffect, useState } from 'react'
import { parseLiffFromRedirectUrl } from 'helpers/url'
import { useNavigate } from 'react-router-dom'

interface UseSubPageProps {
  onSubPageChange: (pageName: string) => void
}

const useSubPage = (props?: UseSubPageProps) => {
  const { onSubPageChange = (pageName) => {} } = props || {}
  const params = parseLiffFromRedirectUrl()
  const pageName = params.get('subpage') ?? ''

  const navigate = useNavigate()
  const [page, setPage] = useState(pageName)
  const [prevPage, setPrevPage] = useState('')

  useEffect(() => {
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  function handlePopState(event) {
    const params = parseLiffFromRedirectUrl()
    const pageName = params.get('subpage') ?? ''
    setPrevPage(page)
    setPage(pageName)
    page !== pageName && onSubPageChange(pageName)
  }

  function setSubPage(pageName: string) {
    setPrevPage(page)
    navigate(getParam('subpage', pageName))
    setPage(pageName)
    page !== pageName && onSubPageChange(pageName)
  }

  function setSubPageWithReplaceHistory(pageName: string) {
    setPrevPage(page)
    navigate(getParam('subpage', pageName), { replace: true })
    setPage(pageName)
    page !== pageName && onSubPageChange(pageName)
  }

  return {
    subPageName: page,
    goToSubPage: setSubPage,
    goToSubPageWithReplaceHistory: setSubPageWithReplaceHistory,
    prevPage,
  }

  function getParam(key, value) {
    key = encodeURI(key)
    value = encodeURI(value)

    var kvp: string | string[] = document.location.search.substr(1).split('&')

    var originalKVP = kvp.slice()
    var i = kvp.length
    var x
    while (i--) {
      x = kvp[i].split('=')

      if (x[0] === key) {
        x[1] = value
        kvp[i] = x.join('=')
        break
      }
    }

    if (i < 0) {
      kvp[kvp.length] = [key, value].join('=')
    }

    if (window.location.search) {
      kvp = kvp.join('&')
    } else {
      kvp = kvp.join('')
    }

    if (value === '') {
      if (originalKVP.length > 1) {
        kvp = kvp.replace(`&${key}=`, '')
        return `${window.location.pathname}?${kvp}`
      } else {
        return `${window.location.pathname}`
      }
    }

    return `${window.location.pathname}?${kvp}`
  }
}

export default useSubPage
